import { render, staticRenderFns } from "./ItemHistoricContent.vue?vue&type=template&id=31f6429b"
import script from "./ItemHistoricContent.vue?vue&type=script&lang=js"
export * from "./ItemHistoricContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports